<template>
  <div id="companyIndicators">
    <div class="item item-box">
      <div class="title">营收与利润</div>
      <div class="box-content">
        <div class="item-r huan-type">
          <div class="item-title">营收（年/季/月）</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.revenue" :dw="'%'"></DomLegend>
            <DomeEchartWrap ref="cRevenue" id="c-revenue" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-r huan-type">
          <div class="item-title">产品线指标</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.revenue" :dw="'%'"></DomLegend>
            <DomeEchartWrap ref="cProduct" id="c-product" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-r huan-type">
          <div class="item-title">效率指标</div>
          <div class="chart-wrap">
            <RangkProgress :list="PopularCities"></RangkProgress>
          </div>
        </div>
        <div class="item-r huan-type">
          <div class="item-title">净利润（年/季/月）</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.netProfit" :dw="'%'"></DomLegend>
            <DomeEchartWrap ref="cNetProfit" id="c-netProfit" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
      </div>
    </div>
    <div class="item item-box">
      <div class="title">产品服务</div>
      <div class="box-content">
        <div class="item-r huan-type ">
          <div class="item-title">服务指标</div>
          <div class="chart-wrap card-wrap">
            <BscSmallCard class="card-item" v-for="item in cServiceIndicatorsLists" :item="item"></BscSmallCard>
          </div>
        </div>
        <div class="item-r huan-type item-r-left">
          <div class="item-title">体验指标</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.experienceIndicators"></DomLegend>
            <DomeEchartWrap ref="cExperienceIndicators" id="c-experienceIndicators" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-r huan-type">
          <div class="item-title">量指标</div>
          <div class="chart-wrap">
            <DomLegend :lists="CompanyIndicators.quantitative" dw="万"></DomLegend>
            <DomeEchartWrap ref="cQuantitative" id="c-quantitative" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
        <div class="item-r huan-type">
          <div class="item-title">率指标</div>
          <div class="chart-wrap">
            <DomLegend dw="%" :lists="CompanyIndicators.rateIndex"></DomLegend>
            <DomeEchartWrap ref="cRateIndex" id="c-rateIndex" class="canvas-wrap"></DomeEchartWrap>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, onMounted, reactive, ref, getCurrentInstance } from '@vue/composition-api'
import DomeEchartWrap from '@/components/echarts/DomeEchartWrap'
import DomLegend from '../components/domLegend.vue'
import RangkProgress from '../components/rangkProgress.vue'
import BscSmallCard from '../components/domSmallCard.vue'

import { UserRetentionPaymentIndexEchartOp, CProductEchart, CRevenueEchartOp } from '../js/index.js'

export default {
  name: 'CompanyIndicators',
  props: [

  ],
  setup (props, ctx) {
    const vm = getCurrentInstance()
    let cServiceIndicatorsLists = reactive([
      // {
      //   name: '投诉量',
      //   val: 100,
      //   hb: 0.6,
      //   tb: 0.2
      // },
      // {
      //   name: '投诉率',
      //   val: 25,
      //   hb: 0.3,
      //   tb: 0.4
      // },
      // {
      //   name: '满意率',
      //   val: 89,
      //   hb: 0.4,
      //   tb: 0.15
      // },
      // {
      //   name: '平均解决时长',
      //   val: '8h',
      //   hb: 0.5,
      //   tb: 0.3
      // }
    ])
    let PopularCities = reactive([
      // { 'name': '人均劳效', 'count': 3, 'rate': '100', dw: '万' },
      // { 'name': '费用率', 'count': 89.40, 'rate': '89.40', dw: '%' },
      // { 'name': '研发费用率', 'count': 83.97, 'rate': '83.97', dw: '%' },
      // { 'name': '存货周转', 'count': 6.21, 'rate': '6.21', dw: '%' },
      // { 'name': '应收周转', 'count': 4.19, 'rate': '4.19', dw: '%' },
      // { 'name': 'ROE', 'count': 0.79, 'rate': '0.79', dw: '%' }
    ])
    let CompanyIndicators = reactive({
      revenue: {},
      netProfit: {},
      product: {},
      experienceIndicators: {},
      quantitative: {},
      rateIndex: {}
    })
    // 营收
    let revenue = reactive({
      name: [],
      nameLabel: [],
      data: [],
      max: 100,
      rate: {
        hb: [],
        tb: []
      }
    })
    let cRevenue = ref(null)
    let cNetProfit = ref(null)
    let cProduct = ref(null)
    let cExperienceIndicators = ref(null)
    let cQuantitative = ref(null)
    let cRateIndex = ref(null)

    function initCreateBarRate () {
      CompanyIndicators.revenue = revenue
      cRevenue.value.setEchartOption(CRevenueEchartOp({ v: this,
        data: revenue
      }))

      // 净利润
      let netProfit = {
        name: ['月达成率', '季达成率', '年达成率'],
        nameLabel: ['年', '季', '月'],
        data: [46.58, 49.58, 93.93],
        max: 100,
        rate: {
          hb: [0.45, -0.48, -0.47],
          tb: [0.67, -0.59, 0.47]
        }
      }
      cNetProfit.value.setEchartOption(CRevenueEchartOp({ v: this,
        data: netProfit
      }))
      CompanyIndicators.netProfit = netProfit
      // 产品指标
      let product = {
        name: ['会员收入占比', '流量收入占比', '软件收入占比', '硬件收入占比'],
        data: [12.15, 6.5, 0.1, 1.43],
        rate: {
          hb: [-0.48, 25.76, 351.02, -10.26],
          tb: [18.97, -22.03, 0, -45.49]
        }
      }
      cProduct.value.setEchartOption(CProductEchart({ v: this,
        data: product
      }))
      // 体验指标
      let experienceIndicators = {
        name: ['体验旅程', '卡设计', '按顺序排列', '硬件收入'],
        data: [14038, 4111, 2438, 2222],
        max: 20000,
        rate: {
          hb: [0.45, -0.48, -0.47, 0.2],
          tb: [0.67, -0.59, 0.47, 0.1]
        }
      }
      cExperienceIndicators.value.setEchartOption(CRevenueEchartOp({ v: this,
        data: experienceIndicators
      }))
      CompanyIndicators.experienceIndicators = experienceIndicators

      // 量指标
      cQuantitative.value.setEchartOption(CRevenueEchartOp({ v: this,
        data: experienceIndicators
      }))
      CompanyIndicators.quantitative = experienceIndicators
      // 率指标
      cRateIndex.value.setEchartOption(CRevenueEchartOp({ v: this,
        data: experienceIndicators
      }))
      CompanyIndicators.rateIndex = experienceIndicators
    }

    onMounted(() => {
      getOrgData()
    })
    let userId = inject('userId')
    /// /
    function getOrgData () {
      vm.proxy.$service.fetch({
        url: '/api/bsc/org/indicators',
        params: {
          empNo: userId
        }
      }).then(res => {
        if (!res) {
          vm.proxy.$alert('您暂未设置组织指标', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.$message({
                type: 'info',
                message: `action: ${action}`
              })
            }
          })
          return
        }
        let cServiceData = res['服务指标']
        let cRateIndexData = res['效率指标']
        let cIncomData = res['营收(年/季/月)']
        // 服务指标
        cServiceData.forEach(v => {
          let { targetName, monthRatio, yearRatio, current, unit } = v
          cServiceIndicatorsLists.push({
            name: targetName,
            hb: monthRatio / 100,
            tb: yearRatio / 100,
            val: current + unit
          })
        })
        // 率指标
        let newCRate = cRateIndexData.sort((a, b) => {
          return b.current - a.current
        }).sort((a, b) => {
          if (a.unit === '万' || b.unit === '万') {
            return -1
          }
          return 0
        })
        newCRate.forEach(v => {
          let { targetName, monthRatio, yearRatio, current, unit } = v
          console.log(unit)
          console.log(unit === '万' ? '100' : current)
          PopularCities.push({
            name: targetName,
            count: current,
            rate: unit === '万' ? '100' : current,
            dw: unit
          })
        })
        // 营收
        cIncomData.forEach(v => {
          let { targetName, monthRatio, yearRatio, current, unit } = v
          revenue.name.push(targetName)
          revenue.nameLabel.push(targetName.slice(0, 1))
          revenue.data.push(current ?? 0)
          revenue.rate.hb.push(monthRatio ?? 0)
          revenue.rate.tb.push(yearRatio ?? 0)
        })

        initCreateBarRate()
      })
    }
    return {
      cServiceIndicatorsLists,
      CompanyIndicators,
      PopularCities,
      cRevenue,
      cProduct,
      cNetProfit,
      cExperienceIndicators,
      cQuantitative,
      cRateIndex
    }
  },
  components: {
    DomeEchartWrap,
    DomLegend,
    RangkProgress,
    BscSmallCard
  }
}
</script>

<style scoped lang="stylus">

#companyIndicators
  .item-box
    .title
      border-bottom: 1px solid #999999cc
      padding-bottom: 15px
.box-content
  display: flex;
  flex-wrap: wrap;
  padding 10px
  justify-content: space-between
.item-r
  display: flex;
  flex-direction: column
  width 398px
  margin-bottom 10px
  .chart-wrap
    display flex
    flex-grow: 1
    margin-bottom: 10px
    justify-content: space-between
    .canvas-wrap
      width 228px
      height 180px
  .chart-wrap.card-wrap
    flex-wrap: wrap
    justify-content: space-between
    align-content: center
    .card-item
      width 193.5px
      height 85.5px
      padding 10px
    .card-item:nth-of-type(n+3)
      margin-top 10px
  .item-title
    color: #000
    text-align center
    margin: 0 0 10px 0
    font-size: 22px
    font-weight: bolder

@media screen and (max-width:2560px)
  .box-content
    justify-content: space-around
@media screen and (max-width:1900px)
  .box-content
    justify-content: space-between
    .item-r:last-of-type
      margin-right: initial
@media screen and (max-width:1500px)
  .box-content
    justify-content: space-around
    .item-r:last-of-type
      margin-right: auto
@media screen and (max-width:1450px)
  .box-content
    justify-content: space-around
    .item-r:last-of-type
      margin-right: initial
</style>

.item-r+.item-r
  margin-left 19px
.item-r.item-r-left
  margin-left 0
